import React from 'react';
import { object, oneOf, func, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Tab, TabList, Tabs, TabPanel } from 'react-context-tabs';

import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import SearchByRef from 'components/SearchByRef';
import SearchByCar from 'components/SearchByCar';
import SearchByVin from 'components/SearchByVin';
import SearchByKba from 'components/SearchByKba';

import { withLabels } from 'containers/withLabels';
import { currentLanguage } from 'utils/currentLanguage';
import CarIcon from 'media/icons/vehicule-model.icon.svg';
import VinIcon from 'media/icons/vehicule-vin.icon.svg';
import ReferenceIcon from 'media/icons/vehicule-reference.icon.svg';

import styles from './SearchTabs.module.scss';
const cx = classNames.bind(styles);

const breadcrumbs = {
  techassist: {
    id: 1,
    active: false,
    url: '/',
  },
  searchResults: {
    id: 2,
    url: '/',
    active: true,
  },
};

const SearchTabs = (props) => {
  const {
    setRefData,
    setRefNoResults,
    getArticlesIds,
    resetSearchResults,
    createTabChangeAction,
    pageType,
    labels,
    selectedTabId,
  } = props;
  const isGermanSite = currentLanguage === 'de';
  const isBrazilSite = currentLanguage === 'pt-br';

  if (isBrazilSite) {
    return (
      <Tabs
        className={cx(pageType, 'search-tabs')}
        selectedTabId={selectedTabId}
        onTabChange={createTabChangeAction}
      >
        <div className={cx('SearchByCar-wrapper', 'white-bg')}>
          <Container>
            {pageType === 'search' && (
              <Breadcrumbs data={breadcrumbs} className={cx('no-border')} />
            )}
            <TabList className={cx('tabs-links')}>
              <Tab tabId="reference" className={cx('tab-item')}>
                <span className={cx('tab-icon', 'icon-reference')}>
                  <ReferenceIcon />
                </span>
                <span className={cx('desktop-text')}>
                  {labels.searchReferenceTabTitle}
                </span>
              </Tab>
            </TabList>
          </Container>
        </div>
        <div className={cx('white-bg', 'search-tabs-container')}>
          <Container>
            <TabPanel tabId="reference">
              <SearchByRef
                pageType={pageType}
                setRefData={setRefData}
                setRefNoResults={setRefNoResults}
              />
            </TabPanel>
          </Container>
        </div>
      </Tabs>
    );
  }

  return (
    <Tabs
      className={cx(pageType, 'search-tabs')}
      selectedTabId={selectedTabId}
      onTabChange={createTabChangeAction}
    >
      <div className={cx('SearchByCar-wrapper', 'white-bg')}>
        <Container>
          {pageType === 'search' && (
            <Breadcrumbs data={breadcrumbs} className={cx('no-border')} />
          )}
          <TabList className={cx('tabs-links')}>
            <Tab tabId="car" className={cx('tab-item')}>
              <span className={cx('tab-icon', 'icon-car')}>
                <CarIcon />
              </span>
              <span className={cx('desktop-text')}>
                {labels.searchCarTabTitle}
              </span>
            </Tab>
            {isGermanSite ? (
              <Tab tabId="kba" className={cx('tab-item')}>
                <span className={cx('tab-icon', 'icon-vin')}>
                  <VinIcon />
                </span>
                <span className={cx('desktop-text')}>
                  {labels.searchKbaTabTitle}
                </span>
              </Tab>
            ) : (
              <Tab tabId="vin" className={cx('tab-item')}>
                <span className={cx('tab-icon', 'icon-vin')}>
                  <VinIcon />
                </span>
                <span className={cx('desktop-text')}>
                  {labels.searchVinTabTitle}
                </span>
              </Tab>
            )}
            <Tab tabId="reference" className={cx('tab-item')}>
              <span className={cx('tab-icon', 'icon-reference')}>
                <ReferenceIcon />
              </span>
              <span className={cx('desktop-text')}>
                {labels.searchReferenceTabTitle}
              </span>
            </Tab>
          </TabList>
        </Container>
      </div>
      <div className={cx('white-bg', 'search-tabs-container')}>
        <Container>
          <TabPanel tabId="car">
            <SearchByCar
              resetSearchResults={resetSearchResults}
              getArticlesIds={getArticlesIds}
              pageType={pageType}
            />
          </TabPanel>
          {isGermanSite ? (
            <TabPanel tabId="kba">
              <SearchByKba
                getArticlesIds={getArticlesIds}
                pageType={pageType}
              />
            </TabPanel>
          ) : (
            <TabPanel tabId="vin">
              <SearchByVin
                getArticlesIds={getArticlesIds}
                pageType={pageType}
              />
            </TabPanel>
          )}
          <TabPanel tabId="reference">
            <SearchByRef
              pageType={pageType}
              setRefData={setRefData}
              setRefNoResults={setRefNoResults}
            />
          </TabPanel>
        </Container>
      </div>
    </Tabs>
  );
};

SearchTabs.propTypes = {
  selectedTabId: string.isRequired,
  pageType: oneOf(['home', 'search']).isRequired,
  setRefData: func.isRequired,
  setRefNoResults: func.isRequired,
  getArticlesIds: func.isRequired,
  resetSearchResults: func.isRequired,
  createTabChangeAction: func.isRequired,
  labels: object.isRequired,
};

export default withLabels(SearchTabs);



// WEBPACK FOOTER //
// ./src/components/SearchTabs/SearchTabs.js